import React, { useState, useEffect, useRef } from 'react';
import { useModal } from '../../context/ModalContext';
import './Header.css';

const navLinks = [
  { href: '#features',      label: 'Why Us' },
  { href: '#nmc-guidelines',label: 'NMC Guidelines' },
  { href: '#documents',     label: 'Documents' },
  { href: '#process',       label: 'Process' },
  { href: '#faq',           label: 'FAQ' },
];

const Header = () => {
  const { openModal } = useModal();
  const [scrolled,  setScrolled]  = useState(false);
  const [menuOpen,  setMenuOpen]  = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close menu on outside click
  useEffect(() => {
    const handler = (e) => {
      if (menuOpen && menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [menuOpen]);

  const handleNavClick = () => setMenuOpen(false);

  return (
    <header className={scrolled ? 'scrolled' : ''} id="hdr" ref={menuRef}>
      {/* Logo */}
      <a href="#home" className="logo">
        <img src="/images/logo.png" alt="MyCollegeBuddy" className="site-logo" />
      </a>

      {/* Desktop Nav */}
      <nav id="nav" className={menuOpen ? 'open' : ''}>
        {navLinks.map(link => (
          <a
            key={link.href}
            href={link.href}
            onClick={handleNavClick}
          >
            {link.label}
          </a>
        ))}
        <button className="nav-btn" onClick={() => { handleNavClick(); openModal(); }}>
          Apply Free Now ✨
        </button>
      </nav>

      {/* Hamburger */}
      <button
        className={`hbg ${menuOpen ? 'hbg--open' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
      >
        <span /><span /><span />
      </button>
    </header>
  );
};

export default Header;